import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { orderBy } from 'lodash';
export const getHelpCenterMatchFromPath = (
  fullPath,
  helpCenterPageIdMap,
  pageTypes,
) => {
  const key = orderBy(
    Object.keys(helpCenterPageIdMap || {}),
    routeKey => routeKey.length,
    ['desc'],
  ).find(routeKey => fullPath.includes(routeKey));

  const matchedHelp = key ? { key, config: helpCenterPageIdMap[key] } : null;

  const isCurrentPageHelpEnabled =
    matchedHelp?.config?.enable &&
    pageTypes?.some(p => p.pageType === matchedHelp.config.pageId);

  return {
    matchedHelp,
    isCurrentPageHelpEnabled,
  };
};

export const useHelpCenterPageMatch = (helpCenterPageIdMap, pageTypes) => {
  const { pathname, search } = useLocation();
  const fullPath = `${pathname}${search}`;
  return useMemo(
    () => getHelpCenterMatchFromPath(fullPath, helpCenterPageIdMap, pageTypes),
    [fullPath, helpCenterPageIdMap, pageTypes],
  );
};

export const getUserInitials = name => {
  if (!name || typeof name !== 'string') return '?';
  const trimmed = name.trim();
  if (!trimmed) return '?';
  if (trimmed.includes('@')) {
    const local = trimmed.split('@')[0];
    const segments = local.split(/[._-]+/).filter(Boolean);
    if (segments.length >= 2) {
      return `${segments[0][0]}${segments[1][0]}`.toUpperCase();
    }
    const single = segments[0] || local;
    return single[0] ? single[0].toUpperCase() : '?';
  }
  const words = trimmed.split(/\s+/).filter(Boolean);
  if (words.length >= 2) {
    return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
  }
  const first = words[0] || trimmed;
  return first[0] ? first[0].toUpperCase() : '?';
};

export const getAppAccessMap = (liveConnectAccess, paiAccess, tcAccess) => ({
  'Live Connect': liveConnectAccess,
  PAI: paiAccess,
  TC: tcAccess,
});
